module.exports = __webpack_public_path__ + "img/DW365-312.e38a122f.jpg";